<template>
    <div id="app">
        <div class="top">
            <div class="line-left"></div>
            <div class="body">
                <div class="header-top">
                    <div class="header-top-left">
                        <div class="header-top-left-logo">
                            <img src="../assets/images/image014.png" width="100%;" />
                        </div>
                        <div class="header-top-left-current-location" v-text="'当前位置：' + currentLocation"></div>
                    </div>
                    <div class="header-top-right">
                        <div class="header-top-right-image">
                            <div class="header-top-right-image-earth">
                                <img src="../assets/images/di1.jpg" height="70px" />
                            </div>
                            <div class="header-top-right-image-title">
                                保护地球 关爱家园
                            </div>
                            <div class="audio-status" @click="playToggle">
                                音乐: <span v-text="playStatus ? '暂停' : '播放'"></span>
                            </div>
                        </div>
                        <div class="header-top-right-marquee">
                            <div class="header-top-right-marquee-css3">善待地球就是善待自己，拯救地球就是拯救未来，珍惜自然资源，共营生命绿色。{{ firstInText }}</div>
                        </div>
                    </div>
                </div>
                <div class="navigate">
                    <ul>
                        <li class="text"><a @click="openPage('/')">首页</a></li>
                        <li class="split"><span></span></li>
                        <li class="text"><a @click="openPage('/ourEarth/index')">我们的地球</a></li>
                        <li class="split"><span></span></li>
                        <li class="text"><a @click="openPage('/greenhouse/index')">温室效应</a></li>
                        <li class="split"><span></span></li>
                        <li class="text"><a @click="openPage('/whitePollution/index')">白色污染</a></li>
                        <li class="split"><span></span></li>
                        <li class="text"><a @click="openPage('/picture/index')">图库</a></li>
                    </ul>
                </div>
                <div class="clear" />
                <router-view />

            </div>
            <div class="line-right"></div>
        </div>
        <div class="fubo-bottom">
            制作: Fu Bo <a href="javascript:void(0)" @click="openPage('/introduce')">&gt;&gt;自述&lt;&lt;</a>
        </div>
        <audio src="../assets/audio/Snowdreams.mp3" id="audio-player" loop="true"/>
    </div>
</template>
<script>
    export default {
        name: "Index",
        data() {
            return {
                enablePage: "",
                playStatus: false,
                firstInText: '（你需要点击右上角播放按钮才能播放背景音乐）',
                firstIn: true,
                pageTitleJson: {
                    "/": "首页",
                    "/ourEarth/index": "我们的地球",
                    "/greenhouse/index": "温室效应",
                    "/whitePollution/index": "白色污染",
                    "/picture/index": "图库",
                    "/introduce": "自述",
                }
            }
        },
        computed: {
            currentLocation: function() {
                document.title = this.pageTitleJson[this.$route.path];
                return this.pageTitleJson[this.$route.path];
            }
        },
        methods: {
            openPage: function(enablePage){
                this.$router.push({path: enablePage})
            },
            playToggle: function () {
                let audioObj = document.getElementById('audio-player')
                audioObj.volume = 0.5;
                audioObj.muted = false;
                if(!this.playStatus) {
                    audioObj.play();
                } else {
                    audioObj.pause();
                }
                this.playStatus = !this.playStatus;
                let th = this
                if(th.firstIn) {
                    th.firstInText = '（你看到了，谢谢你进入我的回忆。）'
                    setTimeout(function() {
                        th.firstInText = ''
                    }, 2500)
                }
                this.firstIn = false
            }
        }
    }
</script>

<style lang="scss">
    body {
        background: url("../assets/images/rgb.jpg") repeat;
    }
    #app {
        width: 764px;
        margin: 0 auto;
    }
    .top {
        height: 800px;
        display: table;
    }
    .bold {
        font-weight: bolder;
    }
    .indent {
        text-indent: 26px;
    }
    .fubo-bottom {
        &,a {
              color: #000;
              text-align: center;
          }
        a {
            margin-left: 50px;
            text-decoration: none;
        }
    }
    .clear {
        clear: both;
    }
    .line-left, .line-right {
        display: table-cell;
        width: 8px;
        height: 100%;
        background: #008000;
    }
    .body {
        width: 748px;
        height: 100%;
    }
    .navigate {
        ul {
            list-style-type: none;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            a {
                text-decoration: none;
                color: #fff;
            }
        }
        li {
            float: left;
            width: 19.92%;
            height: 100%;
            font-size: 12px;
            text-align: center;
            line-height: 25px;
            &.split {
                width: 0.1%;
                height: 15px;
                margin-top: 5px;
                background: linear-gradient(#0277ba, #aaa, #1c519f);
            }
        }
    }
    .header-top {
        height: 110px;
        float: left;
        width: 100%;
        .header-top-left {
            background: #c7f8d9;
            float: left;
            width: 18%;
            height: 100%;
        }
        .header-top-right {
            height: 100%;
            margin-left: 18%;
        }
        .header-top-left-logo {
            height: 90px;
            width: 105px;
            margin: 3px;
            img {
                margin-left: 5px;
            }
        }
        .header-top-left-current-location {
            font-size: 11px;
            text-align: left;
            height: 20px;
            line-height: 12px;
            margin-left: 3px;
        }
        .header-top-right-image {
            background: #0267af;
            width: 100%;
            height: 90px;
            img {
                margin: 10px;
                float: left;
            }
            .audio-status {
                @media(max-width: 1024px) {
                    display: none;
                }
                position: absolute;
                right: 0px;
                top: 0px;
                color: #2668aa;
                cursor: pointer;
            }
        }
        .header-top-right-image-title {
            -webkit-text-stroke: 0.03em #33c;
            -webkit-text-fill-color : transparent;
            font-size: 3em;
            text-shadow: 3px 3px 1px #b2b2b2;
            text-align: left;
            font-family: SimSun;
            line-height: 90px;
        }
        .header-top-right-marquee {
            width: 100%;
            height: 20px;
            overflow: hidden;
            background: #cce8cc;
        }
        .header-top-right-marquee-css3 {
            animation: marquee-css3 18s linear infinite;
            font-size: 12px;
            line-height: 20px;
            font-family: KaiTiGB2312,serif;
            font-weight: bold;
            color: #008080;
            width: 700px;
        }
    }

    @keyframes marquee-css3 {
        0% {
            transform: translate(100%);
        }

        100% {
            transform: translate(-100%);
        }
    }
    .navigate {
        float: left;
        height: 25px;
        width: 100%;
        background: linear-gradient(#0277ba, #1c519f);
        a {
            cursor: pointer;
        }
    }
    .right-content-body {
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;

        &::-webkit-scrollbar {
            width: 0 !important
        }
    }
    .audio-player {
        display: none;
    }
</style>